<div class="modal-header">
    <h5 class="modal-title">Chi tiết danh mục</h5>
    <button type="button" class="close" aria-label="Đóng" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  
  <div class="modal-body">
    <h2>{{ category?.category_name }}</h2>
    <p><strong>Slug:</strong> {{ category?.slug }}</p>
    <p><strong>Đã xuất bản:</strong> {{ category?.published ? 'Có' : 'Không' }}</p>
    <p><strong>Số lượng:</strong> {{ category?.items }}</p>
    <p><strong>Mô tả:</strong> {{ category?.description || 'Không có mô tả' }}</p>
  </div>
  
  <div class="modal-footer">
    <div class="button-group">
      <button type="button" class="btn btn-outline-primary" (click)="editRow(category)">
        <i class="fas fa-edit"></i> Chỉnh sửa
    </button>
    
    <button type="button" class="btn btn-outline-danger" (click)="deleteRow(category)">
        <i class="fas fa-trash-alt"></i> Xóa
    </button>
    
    <button type="button" class="btn btn-outline-secondary" (click)="closeModal()">
        <i class="fas fa-times"></i> Đóng
    </button>
    
    <button *ngIf="!category?.published" type="button" class="btn btn-outline-success" (click)="publish(category.id)">
        <i class="fas fa-paper-plane"></i> Xuất bản
    </button>
    
    </div>
      
  </div>


